import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FilterState } from '../types';

const initialState: FilterState = {
  people: [],
  places: [],
  years: [],
  events: [],
  visibility: 'all',
  sortBy: 'newest',
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<Partial<FilterState>>) => {
      return { ...state, ...action.payload };
    },
    addPersonFilter: (state, action: PayloadAction<string>) => {
      if (!state.people.includes(action.payload)) {
        state.people.push(action.payload);
      }
    },
    removePersonFilter: (state, action: PayloadAction<string>) => {
      state.people = state.people.filter((p) => p !== action.payload);
    },
    addPlaceFilter: (state, action: PayloadAction<string>) => {
      if (!state.places.includes(action.payload)) {
        state.places.push(action.payload);
      }
    },
    removePlaceFilter: (state, action: PayloadAction<string>) => {
      state.places = state.places.filter((p) => p !== action.payload);
    },
    addYearFilter: (state, action: PayloadAction<string>) => {
      if (!state.years.includes(action.payload)) {
        state.years.push(action.payload);
      }
    },
    removeYearFilter: (state, action: PayloadAction<string>) => {
      state.years = state.years.filter((y) => y !== action.payload);
    },
    addEventFilter: (state, action: PayloadAction<string>) => {
      if (!state.events.includes(action.payload)) {
        state.events.push(action.payload);
      }
    },
    removeEventFilter: (state, action: PayloadAction<string>) => {
      state.events = state.events.filter((e) => e !== action.payload);
    },
    setVisibilityFilter: (state, action: PayloadAction<'all' | 'public' | 'private'>) => {
      state.visibility = action.payload;
    },
    setSortBy: (state, action: PayloadAction<'newest' | 'oldest' | 'rating'>) => {
      state.sortBy = action.payload;
    },
    clearFilters: () => initialState,
  },
});

export const {
  setFilter,
  addPersonFilter,
  removePersonFilter,
  addPlaceFilter,
  removePlaceFilter,
  addYearFilter,
  removeYearFilter,
  addEventFilter,
  removeEventFilter,
  setVisibilityFilter,
  setSortBy,
  clearFilters,
} = filterSlice.actions;

export default filterSlice.reducer;
